import * as React from "react";
import "react-flexy-table/dist/index.css";
import "../file/ReactFlexyTable.css";
import {
    ToastsContainer,
    ToastsContainerPosition,
    ToastsStore,
} from "react-toasts";
import { cloneDeep } from "lodash";
import DashUploadDocument from "./DashUploadDocument";
import { compressPdf } from "../PdfCompress/PdfCompressor";
import { callApi } from "../../utils/api";
import HintAboutFile from "../work-file/HintAboutFile";
import { Modal, Input } from "antd";
import DOMPurify from "dompurify";

interface AllProps {
    history: any;
    match: any;
    location?: any; // Added location prop to receive state
}

interface EmailData {
    id: string;
    file_id: string;
    app_id: string;
    subject: string;
    mail_body: string;
    mail_body_text: string;
    message_id: string;
    from_email: string;
    from_email_parsed: Array<{ email: string; name: string }>;
    to_email: string;
    to_email_parsed: Array<{ email: string; name: string }>;
    cc_emails: string;
    cc_emails_parsed: Array<{ email: string; name: string }>;
    received_at: string;
    received_at_formatted: string;
    created_dt_formatted: string;
    attachment_count: string;
    has_attachments: string;
    attachments: Array<{
        id: string;
        mail_thread_id: string;
        filename: string;
        original_filename: string;
        file_type: string;
        file_size: string;
        file_size_formatted: string;
        mime_type: string;
        file_path: string;
        download_url: string;
        created_dt_formatted: string;
    }>;
}

interface FileData {
    file_id: string;
    file_name: string;
    app_id: string;
    file_number: string;
    branch_id: string;
    branch_name: string;
    branch_email: string;
    borrower_name: string;
    created_dt: string;
    created_date_formatted: string;
    file_status: number;
    total_emails: number;
    total_attachments: number;
    emails: EmailData[];
}

declare var $: any;

class ReceivedQueryMailDetails extends React.Component<AllProps> {
    state = {
        fileDetails: null as FileData | null,
        isLoading: false,
        base: [],
        isGlobalPdfCompress: '',
        globalPdfCompressQuality: '',
        isFrontOfficePdfCompressShow: '',
        isSroEcPdfCompressQuality: '',
        isOnlineEcPdfCompressQuality: '',
        deeds: [],
        categoriesList: [],
        isbtnload: false,
        uploadbtn: false,
        // Add this for selected attachments
        selectedAttachments: [] as string[], // Store attachment IDs
        isSelectAll: false,
        previewDoc: '',
        // Add state for HintAboutFile modal
        showHintModal: false,
        // Add state for view attachment modal
        showViewModal: false,
        viewAttachment: null as any,
        viewLoading: false,
        hintSaved: false,
        audioSaved: false,
        hasUploadedFiles: false,
        fromFileDashboard: false,
        pendingQuerysList: [],
        pendingAndReceivedQuerysList: [] as any[],
        queryTreeIdByText: {} as Record<string, string>,
        queryHintMap: {} as Record<string, string[]>,
        pendingHintQuery: null as any,
        pendingHintText: "",
        /** Email thread list: which messages show full mail_body_text */
        threadBodyExpandedById: {} as Record<string, boolean>,
        showCloseUnwantedModal: false,
        closeUnwantedReason: "",
    };

    documentFormat = {
        base: "",
        base_url: "",
        docNoYear: "",
        particular: "xerox",
        type: "",
        isValid: true,
        doc_type: "",
        isPdfCompress: 'off',
        query_id: "",
        query_label: "",
    };

    loadFileWithEmails = (fileId?: string | number) => {
        const { location } = this.props;
        const resolvedFileId = fileId ?? this.props.match?.params?.id;
        const fallbackFileDetails = location?.state?.fileDetails ?? null;
        if (!resolvedFileId) {
            this.setState({ fileDetails: fallbackFileDetails, isLoading: false }, () => {
                this.fetchPdfSettings();
                this.getDeeds();
                this.getPendingQuerysByFileId();
            });
            return Promise.resolve();
        }
        return callApi("POST", "fetch_query_received_mail_details.php", {
            action: "get_file_with_emails",
            file_id: resolvedFileId,
        })
            .then((res) => res.data)
            .then((response: any) => {
                const fileDetails = response?.file ?? (response?.files?.[0] ?? null);
                if (response?.success && fileDetails) {
                    this.setState({ fileDetails, isLoading: false }, () => {
                        this.fetchPdfSettings();
                        this.getDeeds();
                        this.getPendingQuerysByFileId();
                    });
                } else {
                    this.setState({ fileDetails: fallbackFileDetails, isLoading: false }, () => {
                        this.fetchPdfSettings();
                        this.getDeeds();
                        this.getPendingQuerysByFileId();
                    });
                }
            })
            .catch((err) => {
                console.log(err);
                this.setState({ fileDetails: fallbackFileDetails, isLoading: false }, () => {
                    this.fetchPdfSettings();
                    this.getDeeds();
                    this.getPendingQuerysByFileId();
                });
            });
    };

    componentDidMount() {
        const { location, match } = this.props;
        const fileId = match?.params?.id;
        const fromFileDashboard = location?.state?.fromFileDashboard ?? false;
        const listFile: any = location?.state?.fileDetails;
        const needInboundSync =
            !!listFile && (listFile.pending_inbound_queue_count ?? 0) > 0;

        // Always load full file details from API (including mail_body) so details work with optimized list API
        if (fileId) {
            this.setState({ isLoading: true, fromFileDashboard });
            if (needInboundSync) {
                callApi("POST", "fetch_query_received_mail.php", {
                    action: "sync_pending_inbound_queue_for_file",
                    file_id: fileId,
                })
                    .then((res) => res.data)
                    .then((syncRes: any) => {
                        if (!syncRes?.success) {
                            ToastsStore.warning(
                                syncRes?.message ||
                                    "Inbound queue sync reported an issue; showing any mail already saved.",
                            );
                        }
                        return this.loadFileWithEmails(fileId);
                    })
                    .catch((err) => {
                        console.log(err);
                        ToastsStore.error("Inbound sync failed; loading saved mail if any.");
                        return this.loadFileWithEmails(fileId);
                    });
            } else {
                this.loadFileWithEmails(fileId);
            }
        } else if (location?.state?.fileDetails) {
            this.setState({ fileDetails: location.state.fileDetails, fromFileDashboard }, () => {
                this.fetchPdfSettings();
                this.getDeeds();
                this.getPendingQuerysByFileId();
            });
        }
    }

    getPendingQuerysByFileId = () => {
        this.getQueryTreeIdMap().finally(() => {
            callApi("POST", "getPendingQuerysByFileId.php", { file_id: this.props.match.params.id })
            .then((res) => res.data)
            .then((response) => {
                if (response?.result == true) {
                    const pendingQuerysList = this.normalizePendingQueryList(response?.data?.query_pending || []);
                    this.setState({ pendingQuerysList });
                }
                this.getQueryHints();
            })
            .catch((err) => {
                console.log(err);
                this.getQueryHints();
            });
        });
    };

    getQueryTreeIdMap = () => {
        return callApi("POST", "query_tree.php", { fod_fk: this.props.match.params.id })
            .then((res) => res.data)
            .then((response: any) => {
                const idMap: Record<string, string> = {};
                const pendingAndReceivedRows: any[] = [];
                const walk = (nodes: any[]) => {
                    if (!Array.isArray(nodes)) return;
                    nodes.forEach((node: any) => {
                        const details = node?.details || {};
                        const key = this.buildPendingQueryMatchKey(details?.title, details?.reason);
                        if (key && node?.id) {
                            idMap[key] = String(node.id);
                        }
                        if (Array.isArray(node?.children) && node.children.length > 0) {
                            walk(node.children);
                        }
                        const statusValue = String(details?.status ?? "").trim();
                        if (["0", "2"].includes(statusValue) && node?.id) {
                            pendingAndReceivedRows.push({
                                id: String(node.id),
                                mergedValue: `${String(details?.title || node?.name || "").trim()}\nReason: ${String(details?.reason || "").trim()}\n`,
                                status: statusValue,
                                query_status: statusValue,
                                reason: String(details?.reason || "").trim(),
                                title: String(details?.title || node?.name || "").trim(),
                            });
                        }
                    });
                };
                walk(Array.isArray(response) ? response : []);
                this.setState({ queryTreeIdByText: idMap, pendingAndReceivedQuerysList: pendingAndReceivedRows });
                return idMap;
            })
            .catch((err) => {
                console.log(err);
                this.setState({ queryTreeIdByText: {}, pendingAndReceivedQuerysList: [] });
                return {};
            });
    };

    normalizePendingText = (value: any) => String(value || "").replace(/\s+/g, " ").trim().toLowerCase();

    buildPendingQueryMatchKey = (queryText: any, reasonText: any) => {
        const q = this.normalizePendingText(queryText);
        const r = this.normalizePendingText(reasonText);
        if (!q && !r) return "";
        return `${q}|${r}`;
    };

    parsePendingQueryParts = (query: any) => {
        const rawMerged = Array.isArray(query) ? String(query?.[0] || "") : String(query?.mergedValue || query || "");
        const lines = rawMerged.split("\n");
        const firstLine = String(lines[0] || "");
        const cleanQueryText = firstLine.replace(/^\d+\)\s*/, "").trim();
        const reasonLine = lines.find((line: string) => String(line).toLowerCase().includes("reason:")) || "";
        const reason = String(reasonLine).replace(/reason:/i, "").trim();
        return { mergedValue: rawMerged, cleanQueryText, reason };
    };

    normalizePendingQueryList = (list: any[]) => {
        const treeMap: Record<string, string> = (this.state as any).queryTreeIdByText || {};
        return (Array.isArray(list) ? list : []).map((item: any, index: number) => {
            const row = (item && typeof item === "object" && !Array.isArray(item)) ? item : { mergedValue: Array.isArray(item) ? String(item?.[0] || "") : String(item || "") };
            const { cleanQueryText, reason, mergedValue } = this.parsePendingQueryParts(row);
            const matchKey = this.buildPendingQueryMatchKey(cleanQueryText, reason);
            const fallbackIdFromTree = matchKey ? treeMap[matchKey] : "";
            const resolvedId =
                String(
                    row?.id ??
                    row?.ID ??
                    row?.query_id ??
                    row?.queryId ??
                    row?.sourceId ??
                    row?.qid ??
                    fallbackIdFromTree ??
                    "",
                ).trim();
            return {
                ...row,
                mergedValue,
                id: resolvedId || "",
                _rowIndex: index,
            };
        });
    };

    getQueryHints = () => {
        callApi("POST", "query_hint_list.php", { file_id: this.props.match.params.id })
            .then((res) => res.data)
            .then((response) => {
                const hintMap: Record<string, string[]> = {};
                if (response?.result && Array.isArray(response.data)) {
                    response.data.forEach((item: any) => {
                        if (!item?.query_id) return;
                        const key = String(item.query_id);
                        if (!Array.isArray(hintMap[key])) hintMap[key] = [];
                        if (item?.hint && String(item.hint).trim()) {
                            hintMap[key].push(item.hint);
                        }
                    });
                }
                this.setState({ queryHintMap: hintMap });
            })
            .catch((err) => {
                console.log(err);
                this.setState({ queryHintMap: {} });
            });
    };

    resolvePendingQueryId = (query: any) => {
        const possibleId =
            query?._resolvedId ??
            query?.id ??
            query?.ID ??
            query?.query_id ??
            query?.queryId ??
            query?.sourceId ??
            query?.qid ??
            "";
        return String(possibleId).trim();
    };

    addHintForPendingQuery = (query: any) => {
        const queryId = this.resolvePendingQueryId(query);
        const hint = (this.state as any).pendingHintText;
        if (!queryId) {
            ToastsStore.error("Invalid query id. Please refresh and try again.");
            return;
        }
        if (!hint || !hint.trim()) {
            ToastsStore.error("Please enter hint");
            return;
        }
        const user: any = localStorage.getItem("user");
        const userId = user ? JSON.parse(user)["userId"] : "";
        callApi("POST", "query_hint_save.php", {
            file_id: this.props.match.params.id,
            query_id: queryId,
            hint: hint.trim(),
            user_id: userId,
        })
            .then((res) => res.data)
            .then(() => {
                this.setState({ pendingHintQuery: null, pendingHintText: "" });
                this.getPendingQuerysByFileId();
                this.getQueryHints();
                window.dispatchEvent(new CustomEvent("query-hint-updated"));
                ToastsStore.success("Hint added successfully");
            })
            .catch(() => {
                ToastsStore.error("Unable to add hint");
            });
    };

    isPendingQueryReceived = (query: any) => {
        const queryId = this.resolvePendingQueryId(query);
        const statusValue = String(query?.status ?? query?.query_status ?? "").toLowerCase();
        const receivedStatuses = ["2", "query received", "query_received", "received"];
        return receivedStatuses.includes(statusValue) || ((this.state as any).queryHintMap?.[queryId] || []).length > 0;
    };


    fetchPdfSettings = () => {
        callApi("POST", "pdf_category.php")
            .then((res) => res.data)
            .then((response: any) => {
                if (response.result && response.data) {
                    const isGlobalPdfCompress = response.data['Pdf document']?.find((item: any) => item.name == 'Pdf Compression While Uploading Document')?.status == '1';
                    const globalPdfCompressQuality = response.data['Pdf document']?.find((item: any) => item.name == 'Pdf Compression While Uploading Document')?.quality;
                    const isFrontOfficePdfCompressShow = response.data['Pdf document']?.find((item: any) => item.name == 'In Query Upload Show/Hide')?.status == '1';
                    const isSroEcPdfCompressQuality = response.data['Pdf document']?.find((item: any) => item.name == 'SRO Encumbrance Certificate')?.quality;
                    const isOnlineEcPdfCompressQuality = response.data['Pdf document']?.find((item: any) => item.name == 'Online Encumbrance Certificate')?.quality;
                    this.setState({
                        isGlobalPdfCompress,
                        isFrontOfficePdfCompressShow,
                        globalPdfCompressQuality,
                        isSroEcPdfCompressQuality,
                        isOnlineEcPdfCompressQuality
                    });
                }
            })
            .catch((err) => {
                console.log(err);
                ToastsStore.error("Failed to load PDF settings");
            });
    };

    getDeeds = () => {
        callApi("POST", "deed_master_get.php", { category: '' })
            .then((res) => res.data)
            .then((response) => {
                if (response.data && response.data.length) {
                    const deeds = response.data;
                    this.setState({ deeds });
                }
            })
            .catch((err) => {
                console.log(err);
            });
    };

    getCategories = () => {
        callApi("POST", "category.php")
            .then((res) => res.data)
            .then((response) => {
                this.setState({ categoriesList: response.data });
            })
            .catch((err) => {
                console.log(err);
            });
    };

    goBack = () => {
        Modal.confirm({
            title: "Are you sure?",
            content: "Do you really want to go back? Any unsaved changes will be lost.",
            okText: "Yes",
            cancelText: "No",
            onOk: () => {
                this.props.history.goBack();
            },
        });
    };

    // Open Hint About modal
    openHintModal = () => {
        this.setState({ showHintModal: true });
    };

    // Close Hint About modal
    closeHintModal = () => {
        this.setState({ showHintModal: false });
    };

    // Open View Attachment modal
    openViewModal = (attachment: any) => {
        this.setState({
            showViewModal: true,
            viewAttachment: attachment,
            viewLoading: true
        });

        // Set loading to false after a short delay to ensure iframe loads
        setTimeout(() => {
            this.setState({ viewLoading: false });
        }, 500);
    };

    // Close View Attachment modal
    closeViewModal = () => {
        this.setState({
            showViewModal: false,
            viewAttachment: null,
            viewLoading: false
        });
    };

    downloadAttachment = async (attachment: any) => {
        ToastsStore.success(`Downloading ${attachment.original_filename}`);

        const response = await fetch(attachment.download_url);
        const blob = await response.blob();

        const url = window.URL.createObjectURL(blob);

        const link = document.createElement('a');
        link.href = url;
        link.download = attachment.original_filename;
        document.body.appendChild(link);
        link.click();

        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    };

    viewAttachment = (attachment: any) => {
        this.openViewModal(attachment);
    };

    // Check if attachment is PDF
    isPdfAttachment = (attachment: any) => {
        return attachment.file_type === 'pdf' ||
            (attachment.mime_type && String(attachment.mime_type).includes('pdf')) ||
            (attachment.original_filename && attachment.original_filename.toLowerCase().endsWith('.pdf'));
    };

    // Check if attachment is image
    isImageAttachment = (attachment: any) => {
        return attachment.file_type === 'png' ||
            attachment.file_type === 'jpg' ||
            attachment.file_type === 'jpeg' ||
            attachment.file_type === 'gif' ||
            attachment.file_type === 'bmp' ||
            attachment.file_type === 'webp' ||
            (attachment.mime_type && String(attachment.mime_type).includes('image'));
    };

    // Handle individual checkbox selection (only for PDFs)
    handleAttachmentSelect = (attachmentId: string) => {
        const { selectedAttachments } = this.state;
        let newSelectedAttachments = [...selectedAttachments];

        if (newSelectedAttachments.includes(attachmentId)) {
            // Remove if already selected
            newSelectedAttachments = newSelectedAttachments.filter(id => id !== attachmentId);
        } else {
            // Add if not selected
            newSelectedAttachments.push(attachmentId);
        }

        const pdfAttachments = this.getPdfAttachments();
        this.setState({
            selectedAttachments: newSelectedAttachments,
            isSelectAll: newSelectedAttachments.length === pdfAttachments.length && pdfAttachments.length > 0
        });
    };

    // Handle select all/none (only PDFs)
    handleSelectAll = () => {
        const { isSelectAll } = this.state;
        const pdfAttachments = this.getPdfAttachments();

        if (isSelectAll || pdfAttachments.length === 0) {
            // Deselect all
            this.setState({
                selectedAttachments: [],
                isSelectAll: false
            });
        } else {
            // Select all PDFs
            const allPdfIds = pdfAttachments.map(attachment => attachment.id);
            this.setState({
                selectedAttachments: allPdfIds,
                isSelectAll: true
            });
        }
    };

    // Handle upload selected attachments (only PDFs)
    handleUploadSelected = () => {
        const { selectedAttachments } = this.state;
        const allAttachments = this.getAllAttachments();

        if (selectedAttachments.length === 0) {
            ToastsStore.warning("Please select at least one PDF attachment to upload");
            return;
        }

        // Get selected PDF attachments
        const selected = allAttachments.filter(attachment =>
            selectedAttachments.includes(attachment.id) && this.isPdfAttachment(attachment)
        );

        if (selected.length === 0) {
            ToastsStore.warning("No PDF files selected for upload");
            return;
        }

        // Convert attachments to document format
        const baseArray = selected.map(attachment => this.convertAttachmentToDocument(attachment));

        // Set the state with converted documents
        this.setState({ base: baseArray }, () => {
            // Open upload modal
            $("#upload-modal").modal("show");
            this.getCategories();
        });

        ToastsStore.success(`${selected.length} PDF attachment(s) added to upload form`);
    };

    getPendingQueryDropdownOptions = () => {
        const pendingQuerysList: any[] = Array.isArray(this.state.pendingQuerysList) ? this.state.pendingQuerysList : [];
        return pendingQuerysList.map((query: any, index: number) => {
            const mergedValue = query?.mergedValue || '';
            const firstLine = String(mergedValue).split('\n')[0] || '';
            const cleanQueryText = firstLine.replace(/^\d+\)\s*/, '').trim();
            const queryId = this.resolvePendingQueryId(query);
            return {
                value: queryId || String(index + 1),
                label: cleanQueryText || `Pending Query ${index + 1}`,
            };
        });
    };

    // Convert attachment to base document format
    convertAttachmentToDocument = (attachment: any) => {
        return {
            base: attachment.original_filename,
            base_url: attachment.download_url,
            docNoYear: "",
            particular: "xerox",
            type: "",
            isValid: true,
            doc_type: "",
            isPdfCompress: 'off',
            attachmentSource: 'email',
            mail_attachment_id: attachment.id,
            query_id: "",
            query_label: "",
        };
    };

    // Get the latest email (first in the array since it's sorted by received_at DESC)
    getLatestEmail = () => {
        const { fileDetails } = this.state;
        if (fileDetails && fileDetails.emails && fileDetails.emails.length > 0) {
            return fileDetails.emails[0];
        }
        return null;
    };

    isMailAttachmentUploadedToDoc = (attachment: any) =>
        attachment.doc_uploaded === 1 ||
        attachment.doc_uploaded === true ||
        attachment.doc_uploaded === "1";

    // Get all attachments from all emails (exclude rows marked doc_uploaded on tbl_mail_attachments)
    getAllAttachments = () => {
        const { fileDetails }: any = this.state;
        if (!fileDetails || !fileDetails.emails) {
            return [];
        }

        const attachments: any[] = [];

        for (const email of fileDetails.emails) {
            if (!Array.isArray(email?.attachments) || email.attachments.length === 0) {
                continue;
            }
            for (const attachment of email.attachments) {
                if (this.isMailAttachmentUploadedToDoc(attachment)) {
                    continue;
                }
                attachments.push({
                    ...attachment,
                    email_subject: email.subject,
                    email_date: email.received_at_formatted,
                    email_from:
                        email.from_email_parsed?.[0]?.name ||
                        email.from_email_parsed?.[0]?.email ||
                        "Unknown",
                });
            }
        }

        return attachments;
    };

    // Get only PDF attachments
    getPdfAttachments = () => {
        const allAttachments = this.getAllAttachments();
        return allAttachments.filter(attachment => this.isPdfAttachment(attachment));
    };

    // Check if there are any PDF attachments
    hasPdfAttachments = () => {
        return this.getPdfAttachments().length > 0;
    };

    // Get latest email body text (prefer HTML, fallback to text)
    getEmailBodyContent = (email: EmailData | null) => {
        if (!email) return '';

        if (email.mail_body && email.mail_body.trim()) {
            const cleanedMailBody = this.stripMimeArtifactsFromBody(email.mail_body);
            if (cleanedMailBody) {
                return cleanedMailBody;
            }
        }

        if (email.mail_body_text && email.mail_body_text.trim()) {
            const cleanedMailBodyText = this.stripMimeArtifactsFromBody(email.mail_body_text);
            if (cleanedMailBodyText) {
                return cleanedMailBodyText;
            }
        }

        return 'No email content available';
    };

    private stripMimeArtifactsFromBody(raw?: string): string {
        if (!raw || typeof raw !== "string") return "";

        let text = raw.replace(/\r\n/g, "\n");
        text = text.replace(/=\r?\n/g, "");
        text = text.replace(/=([A-Fa-f0-9]{2})/g, (_match, hex) =>
            String.fromCharCode(parseInt(hex, 16))
        );

        // Remove standard MIME preamble line shown by some relays.
        text = text.replace(/^\s*This is a multipart message in MIME format\.?\s*$/gim, "");

        // If text/plain payload header exists, keep body after encoding header.
        const plainHeaderMatch = text.match(
            /Content-Type:\s*text\/plain[\s\S]*?Content-Transfer-Encoding:\s*[a-z0-9-]+\s*/i
        );
        if (plainHeaderMatch && typeof plainHeaderMatch.index === "number") {
            const start = plainHeaderMatch.index + plainHeaderMatch[0].length;
            if (start > 0 && start < text.length) {
                text = text.slice(start);
            }
        }

        // Remove multipart tails like: ------=_NextPart... followed by attachment headers/base64.
        const boundaryMatch = text.match(/(^|\n)-{2,}=?[_A-Za-z0-9.-]*NextPart[^\n]*/i);
        if (boundaryMatch && typeof boundaryMatch.index === "number" && boundaryMatch.index > 0) {
            text = text.slice(0, boundaryMatch.index);
        } else {
            const mimeHeaderMatch = text.match(
                /(^|\n)Content-Type:\s*(image|application|audio|video)\/[a-z0-9.+_-]+[^\n]*\n(?:[^\n]*\n){0,15}Content-Transfer-Encoding:\s*base64/i
            );
            if (mimeHeaderMatch && typeof mimeHeaderMatch.index === "number" && mimeHeaderMatch.index > 0) {
                text = text.slice(0, mimeHeaderMatch.index);
            }
        }

        // Remove inline MIME boundary/header tokens sometimes flattened into one line.
        text = text.replace(/-{2,}=?[_A-Za-z0-9.-]*NextPart[_A-Za-z0-9.-]*/gi, " ");
        text = text.replace(/\bContent-Type:\s*[^;\n]+(?:;\s*[^;\n]+)*/gi, " ");
        text = text.replace(/\bContent-Transfer-Encoding:\s*[a-z0-9-]+/gi, " ");
        text = text.replace(/\bcharset\s*=\s*"?[a-z0-9._-]+"?/gi, " ");
        text = text.replace(/\bboundary\s*=\s*"?.+?"?(?=\s|$)/gi, " ");

        // Drop any remaining long base64-only lines.
        text = text.replace(/^[A-Za-z0-9+/]{180,}={0,2}\s*$/gm, "");

        // Keep only user-facing body if a greeting appears after MIME/meta noise.
        const greetMatch = text.match(/\b(Dear|Hello|Hi)\b[\s\S]{0,20}/i);
        if (greetMatch && typeof greetMatch.index === "number" && greetMatch.index > 0 && greetMatch.index < 1800) {
            text = text.slice(greetMatch.index);
        }

        // Remove leading/trailing quoted-thread headers and inline mail-chain metadata.
        const lines = text.split("\n");
        const cleanedLines: string[] = [];
        let started = false;
        for (const line of lines) {
            const trim = line.trim();
            const lower = trim.toLowerCase();

            if (!trim) {
                if (started) cleanedLines.push("");
                continue;
            }

            if (/^-{2,}\s*original message\s*-{2,}$/i.test(trim) || /^on .+wrote:$/i.test(trim)) {
                break;
            }

            if (/^(from|to|cc|bcc|subject|sent|date)\s*:/i.test(trim)) {
                if (started) break;
                continue;
            }

            if (lower.includes("content-type:") || lower.includes("content-transfer-encoding:")) {
                if (started) break;
                continue;
            }

            if (/^<https?:\/\/[^>]+>$/i.test(trim)) {
                continue;
            }

            if (!started) {
                const emailMatches = trim.match(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}/gi) || [];
                if (emailMatches.length >= 2) {
                    continue;
                }
            }

            started = true;
            cleanedLines.push(line);
        }
        text = cleanedLines.join("\n");

        text = text.replace(/[ \t]{2,}/g, " ");
        text = text.replace(/\n{3,}/g, "\n\n");

        return text.trim();
    }

    private decodeHtmlEntities(raw: string): string {
        try {
            const textarea = document.createElement("textarea");
            textarea.innerHTML = raw;
            return textarea.value;
        } catch {
            return raw;
        }
    }

    private looksLikeHtml(raw: string): boolean {
        if (!raw) return false;
        return /<\s*(html|body|div|p|span|table|tr|td|br|font|a|img|ul|ol|li|h[1-6])\b/i.test(raw);
    }

    private getRenderableHtml(raw?: string): string {
        if (!raw || !raw.trim()) return "";
        const trimmed = this.stripMimeArtifactsFromBody(raw).trim();
        if (!trimmed) return "";
        const maybeDecoded = /&lt;\/?[a-z][\s\S]*?&gt;/i.test(trimmed)
            ? this.decodeHtmlEntities(trimmed)
            : trimmed;
        if (!this.looksLikeHtml(maybeDecoded)) return "";
        return DOMPurify.sanitize(maybeDecoded, { USE_PROFILES: { html: true } });
    }

    private getEmailRenderableHtml(email: EmailData | null): string {
        if (!email) return "";
        return (
            this.getRenderableHtml(email.mail_body) ||
            this.getRenderableHtml(email.mail_body_text)
        );
    }

    private static readonly THREAD_MAIL_BODY_PREVIEW_LEN = 50;

    /** Plain-text bodies sometimes contain CSS left after tag stripping; remove obvious blocks. */
    private static stripCssNoiseFromPlainText(text: string): string {
        let t = text.replace(/<style\b[^>]*>[\s\S]*?<\/style>/gi, "");
        t = t.replace(/<script\b[^>]*>[\s\S]*?<\/script>/gi, "");
        // Orphan rules like "body { margin: 0; }" / "table, td, tr { ... }" at start of string
        const ruleBlock = /^\s*[@#.]?[\w\s,.:#\[\]="-]+\{[^{}]*(?:\{[^{}]*\}[^{}]*)*\}\s*/i;
        let prev = "";
        while (prev !== t) {
            prev = t;
            t = t.replace(ruleBlock, "").trim();
        }
        return t.replace(/\n{3,}/g, "\n\n").trim();
    }

    toggleThreadEmailBodyExpand = (emailId: string) => {
        this.setState((prev:any) => ({
            threadBodyExpandedById: {
                ...prev.threadBodyExpandedById,
                [emailId]: !prev.threadBodyExpandedById[emailId],
            },
        }));
    };

    renderThreadEmailBodyText = (email: EmailData) => {
        const expanded = !!this.state.threadBodyExpandedById[email.id];
        const safeHtml = this.getEmailRenderableHtml(email);

        if (safeHtml) {
            const needsToggle = safeHtml.length > 800;
            return (
                <div style={{ fontSize: "14px", color: "#333", marginTop: "10px" }}>
                    <div
                        className="email-thread-sanitized-html"
                        style={{
                            maxHeight: expanded || !needsToggle ? "none" : 200,
                            overflow: expanded || !needsToggle ? "visible" : "hidden",
                            wordBreak: "break-word",
                        }}
                        dangerouslySetInnerHTML={{ __html: safeHtml }}
                    />
                    {needsToggle && (
                        <button
                            type="button"
                            className="btn btn-link p-0 align-baseline"
                            onClick={() => this.toggleThreadEmailBodyExpand(email.id)}
                            style={{
                                marginTop: "6px",
                                fontSize: "13px",
                                cursor: "pointer",
                            }}
                        >
                            {expanded ? "Read less" : "Read more"}
                        </button>
                    )}
                </div>
            );
        }

        const plainBodySource =
            this.stripMimeArtifactsFromBody(email.mail_body_text || "").trim() ||
            this.stripMimeArtifactsFromBody(email.mail_body || "").trim();

        let text = ReceivedQueryMailDetails.stripCssNoiseFromPlainText(plainBodySource);
        if (!text) {
            return null;
        }
        const { THREAD_MAIL_BODY_PREVIEW_LEN } = ReceivedQueryMailDetails;
        const isLong = text.length > THREAD_MAIL_BODY_PREVIEW_LEN;
        const displayText =
            !isLong || expanded
                ? text
                : `${text.substring(0, THREAD_MAIL_BODY_PREVIEW_LEN)}…`;

        return (
            <div style={{ fontSize: "14px", color: "#6c757d", marginTop: "10px" }}>
                <div
                    style={{
                        whiteSpace: "pre-wrap",
                        wordBreak: "break-word",
                    }}
                >
                    {displayText}
                </div>
                {isLong && (
                    <button
                        type="button"
                        className="btn btn-link p-0 align-baseline"
                        onClick={() => this.toggleThreadEmailBodyExpand(email.id)}
                        style={{
                            marginTop: "6px",
                            fontSize: "13px",
                            cursor: "pointer",
                        }}
                    >
                        {expanded ? "Read less" : "Read more"}
                    </button>
                )}
            </div>
        );
    };

    // Parse email recipients for display
    extractEmailAddress = (rawValue?: string) => {
        if (!rawValue || typeof rawValue !== "string") return "";
        const match = rawValue.match(/[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}/i);
        return match ? match[0].toLowerCase() : rawValue.trim().toLowerCase();
    };

    isHiddenSystemRecipient = (emailAddress?: string) => {
        const normalized = this.extractEmailAddress(emailAddress);
        const [localPart, domainPart] = normalized.split("@");
        if (!localPart || !domainPart) return false;

        // Hide system-generated relay aliases like:
        // 6alxp7pul.69d8a2c4dd0331.90141473.679074@lawhands.org
        if (domainPart === "lawhands.org") {
            const relayAliasPattern = /^[a-z0-9]{6,}\.[a-f0-9]{8,}\.\d{6,}\.\d{4,}$/i;
            return relayAliasPattern.test(localPart);
        }

        return false;
    };

    getEmailRecipients = (email: EmailData | null) => {
        if (!email) return [];

        const recipients: any = [];

        // Add TO recipients
        if (email.to_email_parsed && email.to_email_parsed.length > 0) {
            recipients.push(
                ...email.to_email_parsed.filter(
                    (recipient) => !this.isHiddenSystemRecipient(
                        recipient?.email || recipient?.name
                    )
                )
            );
        }

        // Add CC recipients
        if (email.cc_emails_parsed && email.cc_emails_parsed.length > 0) {
            recipients.push(
                ...email.cc_emails_parsed
                    .filter((cc) =>
                        !this.isHiddenSystemRecipient(cc?.email || cc?.name)
                    )
                    .map(cc => ({
                        ...cc,
                        type: 'cc'
                    }))
            );
        }

        return recipients;
    };

    addUploadDocument = () => {
        let baseArray = cloneDeep(this.state.base);
        baseArray.push(this.documentFormat);
        this.setState({ base: baseArray });
    };

    handleDocumentDetailsChange = (value, index, key) => {
        const invalidDocuments = [
            "26",
            "27",
            "36",
            "35",
            "38",
            "103",
            "78",
            "5",
            "Online Encumbrance Certificate",
        ];
        if (key == "docNoYear") {
            const isValidInput = /^[0-9/-]*$/.test(value);

            if (!isValidInput) {
                console.error(
                    "Invalid input. Please enter only numeric characters, slash, or hyphen."
                );
                return;
            }
            let baseArray = cloneDeep(this.state.base);
            baseArray[index] = {
                ...baseArray[index],
                [key]: value,
            };
            this.setState({ base: baseArray });
        } else {
            let baseArray = cloneDeep(this.state.base);
            if (key == "doc_type") {
                if (invalidDocuments.includes(value)) {
                    baseArray[index] = {
                        ...baseArray[index],
                        docNoYear: "",
                    };
                    this.setState({ base: baseArray });
                }
            }

            baseArray[index] = {
                ...baseArray[index],
                [key]: value,
            };
            this.setState({ base: baseArray });
        }
    };

    handleDocumentFilesChange1 = async (value, index, parentDetails) => {
        const { isGlobalPdfCompress } = this.state;
        this.setState({ isbtnload: true });
        try {
            const fileObj = value.fileList[0];

            // Get base64 (some upload libraries provide directly, some require conversion)
            let base64 = fileObj.base64 || value.base64;

            // If not PDF → directly upload
            if (!fileObj?.type?.includes("pdf")) {
                return this.uploadAndSync(value, base64, index, null);
            }

            // If compression disabled → upload original
            if (!isGlobalPdfCompress || parentDetails.isPdfCompress != 'on' || fileObj.alreadyCompressed) {
                return this.uploadAndSync(value, base64, index, null);
            }

            // Get quality settings
            const { deeds, globalPdfCompressQuality, isSroEcPdfCompressQuality, isOnlineEcPdfCompressQuality }: any = this.state;

            let quality =
                parentDetails.doc_type === 'SRO Encumbrance Certificate'
                    ? isSroEcPdfCompressQuality || globalPdfCompressQuality
                    : parentDetails.doc_type === 'Online Encumbrance Certificate'
                        ? isOnlineEcPdfCompressQuality || globalPdfCompressQuality
                        : deeds?.find((d: any) => d.id === parentDetails.doc_type)?.quality || globalPdfCompressQuality;

            // Compress PDF
            const compressResponse = await compressPdf({
                base64: base64,
                quality,
            });

            // Prevent double compression
            fileObj.alreadyCompressed = true;

            // Upload compressed output
            this.uploadAndSync(value, compressResponse.compressedBase64, index, compressResponse);

        } catch (err) {
            console.error("Error in handleDocumentFilesChange1:", err);
            ToastsStore.error("File processing failed");
        }
    };

    uploadAndSync = (files, base64, index, compressResponse) => {
        // Update UI immediately
        const baseArray = cloneDeep(this.state.base);
        const fileObj = files.fileList[0];

        baseArray[index] = {
            ...baseArray[index],
            base: fileObj.name,
            base_url: base64,
            originalSize: compressResponse?.originalSize || '',
            compressedSize: compressResponse?.compressedSize || '',
        };

        this.setState({ base: baseArray, isbtnload: false });
    };

    deleteDocumentDetails = (index) => {
        const baseArray = cloneDeep(this.state.base);
        baseArray.splice(index, 1);
        this.setState({ base: baseArray });
    };

    deleteFile = (index) => {
        const baseArray = cloneDeep(this.state.base);
        baseArray[index] = {
            ...baseArray[index],
            details: {},
            base: "",
        };
        this.setState({ base: baseArray });
    };

    previewDoc = (file) => {
        this.setState({ previewDoc: file });
    };

    closeuploadfile = () => {
        this.setState({ base: [] });
    };

    validateRequiredFileds = (e) => {
        if (this.state.base && this.state.base.length > 0) {
            this.uploadFiles();
        } else {
        }
    };
    validateDocuments = () => {
        let base: any = this.state.base;
        let isValid = true;
        const invalidDocuments = [
            "26",
            "27",
            "36",
            "35",
            "38",
            "103",
            "78",
            "5",
            "Online Encumbrance Certificate",
        ];
        for (let i = 0; i < base.length; i++) {
            const document = base[i];

            if (invalidDocuments.includes(document.doc_type)) {
                base[i].isValid = true;
            } else {
                if (
                    document.type == "deed" ||
                    document.type == "mother_doc" ||
                    document.type == "title_deed" ||
                    document.type == "ec_doc"
                ) {
                    if (
                        !document.docNoYear ||
                        !document.doc_type ||
                        !document.type ||
                        !document.particular ||
                        !document.base
                    ) {
                        isValid = false;
                        base[i].isValid = false;
                    } else {
                        base[i].isValid = true;
                    }
                } else if (
                    document.type == "rev_rec_doc" ||
                    document.type == "sale_agreement"
                ) {
                    if (
                        !document.doc_type ||
                        !document.type ||
                        !document.particular ||
                        !document.base
                    ) {
                        isValid = false;
                        base[i].isValid = false;
                    } else {
                        base[i].isValid = true;
                    }
                } else {
                    isValid = false;
                    base[i].isValid = false;
                }
            }
        }
        return isValid;
    };
    uploadFiles = () => {
        const isValid = this.validateDocuments();
        let updatedRemainingTime: any = localStorage.getItem(
            "updatedRemainingTime"
        );
        let updatedtime = Math.round(updatedRemainingTime);
        if (!isValid) {
            // Show error message or handle validation error
            ToastsStore.error("Please fill in all fields for this document");
            return;
        } else {
            this.setState({ isbtnload: true });
            this.setState({ uploadbtn: true });
            const user: any = localStorage.getItem("user");
            const userId = user ? JSON.parse(user)["userId"] : "";
            let flag_status;
            if (this.state.fileDetails?.file_status == 7) {
                flag_status = 1;
            } else {
                flag_status = 0;
            }
            const api = "doc_file_upload_mail.php";
            callApi("POST", api, {
                id: this.props.match.params.id,
                uploadfile: this.state.base,
                flag_status: flag_status,
                type: "process",
                userId,
            })
                .then((res) => res)
                .then((response) => {
                    const responseData = response.data;
                    let doc_count = this.state.fileDetails ?
                        Number(this.state.base.length) + Number(this.state.fileDetails.total_attachments) :
                        this.state.base.length;

                    if (responseData.success === true) {
                        const uploadedIds = new Set(
                            (this.state.base as any[])
                                .map((b) => Number(b.mail_attachment_id))
                                .filter((n) => n > 0),
                        );
                        let request = {
                            file_id: this.props.match.params.id,
                            doc_count: doc_count,
                            balance_min: updatedtime,
                        };
                        callApi("POST", "file_time.php", request)
                            .then((res) => res.data)
                            .then((response) => {
                                if (response.status == "200") {
                                    localStorage.removeItem("updatedRemainingTime");
                                }
                            });
                        if (this.state.fileDetails?.file_status == 7) {
                            this.timeUpdate(this.props.match.params.id, "query receive");
                        } else {
                            if (this.state.fileDetails?.file_status != 10) {
                                this.timeUpdate(this.props.match.params.id, "before query raise");
                            }
                        }
                        this.setState((prev: any) => {
                            const fd = prev.fileDetails;
                            if (!fd?.emails) {
                                return {
                                    isbtnload: false,
                                    uploadbtn: false,
                                    hasUploadedFiles: true,
                                    base: [],
                                    selectedAttachments: [],
                                    isSelectAll: false,
                                };
                            }
                            const emails = fd.emails.map((e: any) => ({
                                ...e,
                                attachments: (e.attachments || []).map((a: any) =>
                                    uploadedIds.has(Number(a.id)) ? { ...a, doc_uploaded: 1 } : a,
                                ),
                            }));
                            return {
                                isbtnload: false,
                                uploadbtn: false,
                                hasUploadedFiles: true,
                                base: [],
                                selectedAttachments: [],
                                isSelectAll: false,
                                fileDetails: { ...fd, emails },
                            };
                        }, () => {
                            this.loadFileWithEmails(this.props.match.params.id);
                        });
                        $("#upload-modal").modal("hide");

                        ToastsStore.success("File(s) Uploaded Successully");
                    } else {
                        this.setState({ uploadbtn: false });
                        this.setState({ isbtnload: false });
                        ToastsStore.success("File(s) Not Uploaded");
                    }
                })
                .catch((err) => {
                    this.setState({ isbtnload: false });
                    this.setState({ uploadbtn: false });
                });
        }
    };

    timeUpdate = (fileid, type) => {
        const loginuser: any = localStorage.getItem("user1");
        let req;
        if (type == "query receive") {
            req = {
                query_received_by: JSON.parse(loginuser),
                id: fileid,
                reason: "Query Received",
                created_by: JSON.parse(loginuser),
                color: "#edada0",
            };
        }
        callApi("POST", "time_update.php", req)
            .then((res) => res.data)
            .then((response) => { });
    };

    assignToQueue = (type: any) => {
        const moveType = type == 'assignQueue' ? 'assigning' : 'move';
        const isMoveQueue = type === "moveQueue";
        const shouldRequireHint = !isMoveQueue || !this.state.hasUploadedFiles;
        if (shouldRequireHint && (this.state.hintSaved === false || this.state.audioSaved === false)) {
            ToastsStore.error(`Please provide hint the file before ${moveType} to queue`);
            return;
        }

        Modal.confirm({
            title: "Are you sure?",
            content: `Do you want to ${moveType} this file to the queue?`,
            okText: "Yes",
            cancelText: "No",
            onOk: () => {
                const loginuser: any = localStorage.getItem("user1");

                let req = {
                    file_id: this.props.match.params.id,
                    assigned_to: JSON.parse(loginuser),
                };

                callApi("POST", "fetch_query_mail_assign_file_queue.php", req)
                    .then((res) => res.data)
                    .then((response) => {
                        if (response.success) {
                            ToastsStore.success("File assigned to queue successfully");
                            this.setState({ hintSaved: false });
                            this.setState({ audioSaved: false });
                            this.props.history.goBack();
                        } else {
                            ToastsStore.error("Failed to assign file to queue");
                        }
                    });
            },
        });
    };

    openCloseUnwantedModal = () => {
        this.setState({ showCloseUnwantedModal: true, closeUnwantedReason: "" });
    };

    handleCloseUnwantedModalCancel = () => {
        this.setState({ showCloseUnwantedModal: false, closeUnwantedReason: "" });
    };

    submitCloseUnwantedMail = () => {
        const reason = (this.state.closeUnwantedReason || "").trim();
        if (!reason) {
            ToastsStore.error("Please enter a reason for closing this mail");
            return Promise.reject();
        }
        const loginuser: any = localStorage.getItem("user1");
        const req = {
            file_id: this.props.match.params.id,
            assigned_to: JSON.parse(loginuser),
            close_reason: reason,
        };
        return callApi("POST", "close_unwanted_mail.php", req)
            .then((res) => res.data)
            .then((response) => {
                if (response.success) {
                    this.setState({
                        hintSaved: false,
                        audioSaved: false,
                        showCloseUnwantedModal: false,
                        closeUnwantedReason: "",
                    });
                    this.props.history.goBack();
                    ToastsStore.success(response.message);
                } else {
                    ToastsStore.error(response.message || "Failed to close file");
                    return Promise.reject();
                }
            });
    };
    
    handleHintSaved = () => {
        this.setState({ hintSaved: true });
    };

    handleAudioSaved = () => {
        this.setState({ audioSaved: true });
    };

    render() {
        const { fileDetails, isLoading, selectedAttachments, isSelectAll, showHintModal, showViewModal, viewAttachment, viewLoading, showCloseUnwantedModal, closeUnwantedReason, pendingHintQuery, pendingHintText }: any = this.state;
        if (isLoading) {
            return (
                <section className="pcoded-main-container">
                    <div className="pcoded-wrapper">
                        <div className="pcoded-content">
                            <div className="pcoded-inner-content">
                                <div className="main-body">
                                    <div className="page-wrapper">
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <div className="card">
                                                    <div className="card-body text-center py-5">
                                                        <div className="spinner-border text-primary" role="status">
                                                            <span className="sr-only">Loading...</span>
                                                        </div>
                                                        <p className="mt-3">Loading file details...</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            );
        }

        if (!fileDetails) {
            return (
                <section className="pcoded-main-container">
                    <ToastsContainer
                        store={ToastsStore}
                        position={ToastsContainerPosition.TOP_RIGHT}
                    />
                    <div className="pcoded-wrapper">
                        <div className="pcoded-content">
                            <div className="pcoded-inner-content">
                                <div className="main-body">
                                    <div className="page-wrapper">
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <div className="card">
                                                    <div className="card-body text-center py-5">
                                                        <p className="text-muted">No file details found</p>
                                                        <button
                                                            className="btn btn-outline-secondary mt-3"
                                                            onClick={this.goBack}
                                                        >
                                                            <i className="fa fa-arrow-left"></i> Back to List
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>
            );
        }

        const latestEmail = this.getLatestEmail();
        const allAttachments = this.getAllAttachments();
        const pdfAttachments = this.getPdfAttachments();
        const hasPdfAttachments = this.hasPdfAttachments();
        const emailBody = this.getEmailBodyContent(latestEmail);
        const latestEmailHtml = this.getEmailRenderableHtml(latestEmail);
        const recipients = this.getEmailRecipients(latestEmail).filter(
            (recipient: any) => !this.isHiddenSystemRecipient(recipient?.email || recipient?.name)
        );

        return (
            <section className="pcoded-main-container">
                <ToastsContainer
                    store={ToastsStore}
                    position={ToastsContainerPosition.TOP_RIGHT}
                />
                <div className="pcoded-wrapper">
                    <div className="pcoded-content">
                        <div className="pcoded-inner-content">
                            <div className="main-body">
                                <div className="page-wrapper">
                                    {/* Header with Back Button */}
                                    <div className="row mb-3 mail-details">
                                        <div className="col-sm-6">
                                            <button
                                                className="btn btn-outline-secondary"
                                                onClick={this.goBack}
                                                style={{
                                                    borderRadius: '5px',
                                                    padding: '8px 20px',
                                                    fontSize: '14px'
                                                }}
                                            >
                                                <i className="fa fa-arrow-left"></i> Back to List
                                            </button>
                                        </div>
                                        <div className="col-sm-6">
                                            <button
                                                className="btn btn-outline-secondary"
                                                onClick={this.openHintModal}
                                                style={{
                                                    borderRadius: '5px',
                                                    padding: '8px 20px',
                                                    fontSize: '14px'
                                                }}
                                            >
                                                <i className="fa fa-lightbulb-o"></i> Hint About
                                            </button>
                                            {!this.state.fromFileDashboard && (!hasPdfAttachments || allAttachments.length == 0) &&
                                                <button
                                                    className="btn btn-outline-secondary"
                                                    onClick={() => this.assignToQueue("assignQueue")}
                                                    style={{
                                                        borderRadius: '5px',
                                                        padding: '8px 20px',
                                                        fontSize: '14px',
                                                        marginLeft: '10px'
                                                    }}
                                                >
                                                    Assign in Queue
                                                </button>
                                            }
                                            {!this.state.fromFileDashboard && (hasPdfAttachments && allAttachments.length > 0) &&
                                                <button
                                                    className="btn btn-outline-secondary"
                                                    onClick={() => this.assignToQueue('moveQueue')}
                                                    style={{
                                                        borderRadius: '5px',
                                                        padding: '8px 20px',
                                                        fontSize: '14px',
                                                        marginLeft: '10px',
                                                        backgroundColor: '#28a745',
                                                        borderColor: '#28a745',
                                                        color: 'white',
                                                    }}
                                                >
                                                    Complete & Close Mail
                                                </button>
                                            }
                                            {!this.state.fromFileDashboard &&
                                                <button
                                                    className="btn btn-outline-secondary"
                                                    onClick={() => this.openCloseUnwantedModal()}
                                                    style={{
                                                        borderRadius: '5px',
                                                        padding: '8px 20px',
                                                        fontSize: '14px',
                                                        marginLeft: '10px',
                                                        backgroundColor: '#f6142b',
                                                        borderColor: '#f6142b',
                                                        color: 'white',
                                                    }}
                                                >
                                                    Close Unwanted Mail
                                                </button>
                                            }
                                        </div>
                                    </div>

                                    {/* File Information Card */}
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="card" style={{ marginBottom: '20px' }}>
                                                <div className="card-header" style={{
                                                    background: '#667eea',
                                                    color: 'white',
                                                    padding: '15px 20px'
                                                }}>
                                                    <h5 style={{ margin: 0, fontSize: '18px', fontWeight: 600 }}>
                                                        <i className="fa fa-folder-open"></i> File Information
                                                    </h5>
                                                </div>
                                                <div className="card-body" style={{ padding: '25px' }}>
                                                    <div className="row">
                                                        <div className="col-md-3 col-sm-6 mb-3">
                                                            <div style={{
                                                                padding: '15px',
                                                                background: '#f8f9fa',
                                                                borderRadius: '8px',
                                                                borderLeft: '4px solid #667eea'
                                                            }}>
                                                                <small style={{
                                                                    color: '#6c757d',
                                                                    fontSize: '12px',
                                                                    fontWeight: 600,
                                                                    textTransform: 'uppercase'
                                                                }}>File Number</small>
                                                                <p style={{
                                                                    margin: '5px 0 0 0',
                                                                    fontSize: '16px',
                                                                    fontWeight: 600,
                                                                    color: '#2c3e50'
                                                                }}>{fileDetails.file_name || fileDetails.file_number}</p>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3 col-sm-6 mb-3">
                                                            <div style={{
                                                                padding: '15px',
                                                                background: '#f8f9fa',
                                                                borderRadius: '8px',
                                                                borderLeft: '4px solid #f093fb'
                                                            }}>
                                                                <small style={{
                                                                    color: '#6c757d',
                                                                    fontSize: '12px',
                                                                    fontWeight: 600,
                                                                    textTransform: 'uppercase'
                                                                }}>App ID</small>
                                                                <p style={{
                                                                    margin: '5px 0 0 0',
                                                                    fontSize: '14px',
                                                                    fontWeight: 600,
                                                                    color: '#2c3e50'
                                                                }}>{fileDetails.app_id}</p>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3 col-sm-6 mb-3">
                                                            <div style={{
                                                                padding: '15px',
                                                                background: '#f8f9fa',
                                                                borderRadius: '8px',
                                                                borderLeft: '4px solid #4facfe'
                                                            }}>
                                                                <small style={{
                                                                    color: '#6c757d',
                                                                    fontSize: '12px',
                                                                    fontWeight: 600,
                                                                    textTransform: 'uppercase'
                                                                }}>Borrower Name</small>
                                                                <p style={{
                                                                    margin: '5px 0 0 0',
                                                                    fontSize: '16px',
                                                                    fontWeight: 600,
                                                                    color: '#2c3e50'
                                                                }}>{fileDetails.borrower_name}</p>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3 col-sm-6 mb-3">
                                                            <div style={{
                                                                padding: '15px',
                                                                background: '#f8f9fa',
                                                                borderRadius: '8px',
                                                                borderLeft: '4px solid #43e97b'
                                                            }}>
                                                                <small style={{
                                                                    color: '#6c757d',
                                                                    fontSize: '12px',
                                                                    fontWeight: 600,
                                                                    textTransform: 'uppercase'
                                                                }}>Branch</small>
                                                                <p style={{
                                                                    margin: '5px 0 0 0',
                                                                    fontSize: '16px',
                                                                    fontWeight: 600,
                                                                    color: '#2c3e50'
                                                                }}>{fileDetails.branch_name}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="row mt-3">
                                                        <div className="col-md-3 col-sm-6 mb-3">
                                                            <div style={{
                                                                padding: '15px',
                                                                background: '#f8f9fa',
                                                                borderRadius: '8px',
                                                                borderLeft: '4px solid #ffecd2'
                                                            }}>
                                                                <small style={{
                                                                    color: '#6c757d',
                                                                    fontSize: '12px',
                                                                    fontWeight: 600,
                                                                    textTransform: 'uppercase'
                                                                }}>Bank Name</small>
                                                                <p style={{
                                                                    margin: '5px 0 0 0',
                                                                    fontSize: '16px',
                                                                    fontWeight: 600,
                                                                    color: '#2c3e50'
                                                                }}>
                                                                    {fileDetails?.bank_name}
                                                                </p>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3 col-sm-6 mb-3">
                                                            <div style={{
                                                                padding: '15px',
                                                                background: '#f8f9fa',
                                                                borderRadius: '8px',
                                                                borderLeft: '4px solid #ff9a9e'
                                                            }}>
                                                                <small style={{
                                                                    color: '#6c757d',
                                                                    fontSize: '12px',
                                                                    fontWeight: 600,
                                                                    textTransform: 'uppercase'
                                                                }}>Total Emails</small>
                                                                <p style={{
                                                                    margin: '5px 0 0 0',
                                                                    fontSize: '16px',
                                                                    fontWeight: 600,
                                                                    color: '#2c3e50'
                                                                }}>{fileDetails.total_emails}</p>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3 col-sm-6 mb-3">
                                                            <div style={{
                                                                padding: '15px',
                                                                background: '#f8f9fa',
                                                                borderRadius: '8px',
                                                                borderLeft: '4px solid #a18cd1'
                                                            }}>
                                                                <small style={{
                                                                    color: '#6c757d',
                                                                    fontSize: '12px',
                                                                    fontWeight: 600,
                                                                    textTransform: 'uppercase'
                                                                }}>Total Attachments</small>
                                                                <p style={{
                                                                    margin: '5px 0 0 0',
                                                                    fontSize: '16px',
                                                                    fontWeight: 600,
                                                                    color: '#2c3e50'
                                                                }}>{fileDetails.total_attachments}</p>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-3 col-sm-6 mb-3">
                                                            <div style={{
                                                                padding: '15px',
                                                                background: '#f8f9fa',
                                                                borderRadius: '8px',
                                                                borderLeft: '4px solid #fad0c4'
                                                            }}>
                                                                <small style={{
                                                                    color: '#6c757d',
                                                                    fontSize: '12px',
                                                                    fontWeight: 600,
                                                                    textTransform: 'uppercase'
                                                                }}>File Created</small>
                                                                <p style={{
                                                                    margin: '5px 0 0 0',
                                                                    fontSize: '16px',
                                                                    fontWeight: 600,
                                                                    color: '#2c3e50'
                                                                }}>{fileDetails.login_dt}</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Pending / Query Received Card */}
                                    {this.state.pendingAndReceivedQuerysList && this.state.pendingAndReceivedQuerysList.length > 0 && (
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <div className="card" style={{ marginBottom: '20px' }}>
                                                    <div className="card-header" style={{
                                                        background: '#ff6b6b',
                                                        color: 'white',
                                                        padding: '15px 20px',
                                                        display: 'flex',
                                                        justifyContent: 'space-between',
                                                        alignItems: 'center'
                                                    }}>
                                                        <h5 style={{ margin: 0, fontSize: '18px', fontWeight: 600 }}>
                                                            <i className="fa fa-question-circle"></i> Pending Queries ({this.state.pendingAndReceivedQuerysList.length})
                                                        </h5>
                                                    </div>
                                                    <div className="card-body" style={{ padding: '0' }}>
                                                        <div className="table-responsive">
                                                            <table className="table table-hover" style={{ margin: 0, border: 'none' }}>
                                                                <thead style={{
                                                                    background: '#f8f9fa',
                                                                    borderBottom: '2px solid #e9ecef',
                                                                    border: 'none'
                                                                }}>
                                                                    <tr style={{ border: 'none' }}>
                                                                        <th style={{
                                                                            padding: '15px 20px',
                                                                            fontSize: '14px',
                                                                            fontWeight: 600,
                                                                            color: '#495057',
                                                                            width: '60px',
                                                                            textAlign: 'center',
                                                                            border: 'none'
                                                                        }}>#</th>
                                                                        <th style={{
                                                                            padding: '15px 20px',
                                                                            fontSize: '14px',
                                                                            fontWeight: 600,
                                                                            color: '#495057',
                                                                            border: 'none'
                                                                        }}>Query Details</th>
                                                                        <th style={{
                                                                            padding: '15px 20px',
                                                                            fontSize: '14px',
                                                                            fontWeight: 600,
                                                                            color: '#495057',
                                                                            border: 'none'
                                                                        }}>Reason</th>
                                                                        <th style={{
                                                                            padding: '15px 20px',
                                                                            fontSize: '14px',
                                                                            fontWeight: 600,
                                                                            color: '#495057',
                                                                            width: '120px',
                                                                            textAlign: 'center',
                                                                            border: 'none'
                                                                        }}>Status</th>
                                                                        <th style={{
                                                                            padding: '15px 20px',
                                                                            fontSize: '14px',
                                                                            fontWeight: 600,
                                                                            color: '#495057',
                                                                            width: '140px',
                                                                            textAlign: 'center',
                                                                            border: 'none'
                                                                        }}>Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {this.state.pendingAndReceivedQuerysList.map((query: any, index: any) => {
                                                                        // Parse the mergedValue to extract query number and text
                                                                        const mergedValue = query?.mergedValue || '';
                                                                        const parts = mergedValue.split('\n');
                                                                        const queryText = parts[0]?.trim() || '';
                                                                        const reason = parts[1]?.replace('Reason:', '')?.trim() || 'No reason provided';

                                                                        // Remove the number prefix (e.g., "1) ", "2) ") from query text
                                                                        const cleanQueryText = queryText.replace(/^\d+\)\s*/, '');
                                                                        const isQueryReceived = this.isPendingQueryReceived(query);

                                                                        return (
                                                                            <tr key={index} style={{
                                                                                borderBottom: '1px solid #f1f3f4',
                                                                                transition: 'all 0.2s ease',
                                                                                border: 'none'
                                                                            }}>
                                                                                <td style={{
                                                                                    padding: '15px 20px',
                                                                                    fontSize: '14px',
                                                                                    fontWeight: 600,
                                                                                    color: '#2c3e50',
                                                                                    textAlign: 'center',
                                                                                    verticalAlign: 'middle',
                                                                                    border: 'none'
                                                                                }}>
                                                                                    {index + 1}
                                                                                </td>
                                                                                <td style={{
                                                                                    padding: '15px 20px',
                                                                                    fontSize: '14px',
                                                                                    color: '#495057',
                                                                                    verticalAlign: 'middle',
                                                                                    border: 'none',
                                                                                    lineHeight: '1.5'
                                                                                }}>
                                                                                    <div style={{ display: 'flex', alignItems: 'flex-start' }}>
                                                                                        <div style={{ flex: 1, fontWeight: 700 }}>
                                                                                            {cleanQueryText.split('**').map((part, i) => {
                                                                                                if (i % 2 === 1) {
                                                                                                    return (
                                                                                                        <strong key={i} style={{ color: '#2c3e50' }}>
                                                                                                            {part}
                                                                                                        </strong>
                                                                                                    );
                                                                                                }
                                                                                                return part;
                                                                                            })}
                                                                                        </div>
                                                                                    </div>
                                                                                </td>
                                                                                <td style={{
                                                                                    padding: '15px 20px',
                                                                                    fontSize: '14px',
                                                                                    color: '#6c757d',
                                                                                    verticalAlign: 'middle',
                                                                                    border: 'none',
                                                                                    width: '500px'
                                                                                }}>
                                                                                    <div style={{
                                                                                        padding: '6px 12px',
                                                                                        background: '#e9ecef',
                                                                                        borderRadius: '4px',
                                                                                        fontSize: '13px',
                                                                                        fontWeight: 500
                                                                                    }}>
                                                                                        {reason}
                                                                                    </div>
                                                                                </td>
                                                                                <td style={{
                                                                                    padding: '15px 20px',
                                                                                    fontSize: '14px',
                                                                                    textAlign: 'center',
                                                                                    verticalAlign: 'middle',
                                                                                    border: 'none'
                                                                                }}>
                                                                                    <span style={{
                                                                                        display: 'inline-flex',
                                                                                        alignItems: 'center',
                                                                                        gap: '6px',
                                                                                        padding: '6px 12px',
                                                                                        background: isQueryReceived ? '#28a745' : '#ff6b6b',
                                                                                        color: 'white',
                                                                                        borderRadius: '20px',
                                                                                        fontSize: '12px',
                                                                                        fontWeight: 600,
                                                                                        textTransform: 'uppercase'
                                                                                    }}>
                                                                                        <i className={`fa ${isQueryReceived ? 'fa-check' : 'fa-times'}`} style={{ fontSize: '10px' }}></i>
                                                                                        {isQueryReceived ? 'QUERY RECEIVED' : 'PENDING'}
                                                                                    </span>
                                                                                </td>
                                                                                <td style={{
                                                                                    padding: '15px 20px',
                                                                                    textAlign: 'center',
                                                                                    verticalAlign: 'middle',
                                                                                    border: 'none'
                                                                                }}>
                                                                                    <button
                                                                                        type="button"
                                                                                        className="query-client-requery-btn"
                                                                                        title="Add Hint"
                                                                                        style={{
                                                                                            minWidth: '86px',
                                                                                            height: '34px',
                                                                                            padding: '0 14px',
                                                                                            display: 'inline-flex',
                                                                                            alignItems: 'center',
                                                                                            justifyContent: 'center',
                                                                                            gap: '6px',
                                                                                            background: 'linear-gradient(135deg, #14b8a6 0%, #0d9488 100%)',
                                                                                            border: '1px solid #0f766e',
                                                                                            color: '#ffffff',
                                                                                            borderRadius: '8px',
                                                                                            fontSize: '13px',
                                                                                            fontWeight: 600,
                                                                                            boxShadow: '0 2px 6px rgba(13, 148, 136, 0.28)',
                                                                                            transition: 'all 0.2s ease',
                                                                                        }}
                                                                                        onClick={() =>
                                                                                            this.setState({
                                                                                                pendingHintQuery: query,
                                                                                                pendingHintText: "",
                                                                                            })
                                                                                        }
                                                                                    >
                                                                                        <i className="fa fa-lightbulb-o" style={{ fontSize: '13px' }}></i>
                                                                                        Hint
                                                                                    </button>
                                                                                </td>
                                                                            </tr>
                                                                        );
                                                                    })}
                                                                </tbody>
                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {/* Latest Email Content Card */}
                                    {latestEmail && (
                                        <div className="row">
                                            <div className="col-sm-12">
                                                <div className="card" style={{ marginBottom: '20px' }}>
                                                    <div className="card-header" style={{
                                                        background: '#f093fb',
                                                        color: 'white',
                                                        padding: '15px 20px'
                                                    }}>
                                                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                                            <h5 style={{ margin: 0, fontSize: '18px', fontWeight: 600 }}>
                                                                <i className="fa fa-envelope"></i> Latest Query Email
                                                            </h5>
                                                            <span style={{ fontSize: '14px', opacity: 0.9 }}>
                                                                {latestEmail.received_at_formatted}
                                                            </span>
                                                        </div>
                                                    </div>
                                                    <div className="card-body" style={{ padding: '0' }}>
                                                        {/* Email Header */}
                                                        <div style={{
                                                            padding: '20px 25px',
                                                            background: '#f8f9fa',
                                                            borderBottom: '1px solid #dee2e6'
                                                        }}>
                                                            <div style={{ marginBottom: '12px' }}>
                                                                <strong style={{
                                                                    color: '#495057',
                                                                    fontSize: '14px',
                                                                    display: 'inline-block',
                                                                    width: '80px'
                                                                }}>Subject:</strong>
                                                                <span style={{
                                                                    fontSize: '16px',
                                                                    fontWeight: 600,
                                                                    color: '#2c3e50'
                                                                }}>{latestEmail.subject}</span>
                                                            </div>
                                                            <div style={{ marginBottom: '8px' }}>
                                                                <strong style={{
                                                                    color: '#495057',
                                                                    fontSize: '14px',
                                                                    display: 'inline-block',
                                                                    width: '80px'
                                                                }}>From:</strong>
                                                                <span style={{ fontSize: '14px', color: '#6c757d' }}>
                                                                    {latestEmail.from_email_parsed?.[0]?.name ?
                                                                        `${latestEmail.from_email_parsed[0].name} <${latestEmail.from_email_parsed[0].email}>` :
                                                                        latestEmail.from_email_parsed?.[0]?.email || 'Unknown'}
                                                                </span>
                                                            </div>
                                                            {recipients.length > 0 && (
                                                                <div style={{ marginBottom: '8px' }}>
                                                                    <strong style={{
                                                                        color: '#495057',
                                                                        fontSize: '14px',
                                                                        display: 'inline-block',
                                                                        width: '80px',
                                                                        verticalAlign: 'top'
                                                                    }}>To/CC:</strong>
                                                                    <div style={{ display: 'inline-block', maxWidth: 'calc(100% - 80px)' }}>
                                                                        {recipients.slice(0, 3).map((recipient: any, idx) => (
                                                                            <span key={idx} style={{
                                                                                fontSize: '14px',
                                                                                color: '#6c757d',
                                                                                display: 'block',
                                                                                marginBottom: '4px'
                                                                            }}>
                                                                                {recipient.name ? `${recipient.name} <${recipient.email}>` : recipient.email}
                                                                                {recipient.type === 'cc' && <span style={{ fontSize: '12px', color: '#999', marginLeft: '5px' }}>(CC)</span>}
                                                                            </span>
                                                                        ))}
                                                                        {recipients.length > 3 && (
                                                                            <span style={{ fontSize: '12px', color: '#999' }}>
                                                                                +{recipients.length - 3} more
                                                                            </span>
                                                                        )}
                                                                    </div>
                                                                </div>
                                                            )}
                                                        </div>

                                                        {/* Email Body */}
                                                        <div style={{
                                                            padding: '25px',
                                                            minHeight: '200px',
                                                            background: 'white',
                                                            maxHeight: '400px',
                                                            overflowY: 'auto'
                                                        }}>
                                                            {latestEmailHtml ? (
                                                                <div dangerouslySetInnerHTML={{ __html: latestEmailHtml }} />
                                                            ) : (
                                                                <pre style={{
                                                                    fontFamily: 'inherit',
                                                                    fontSize: '14px',
                                                                    lineHeight: '1.8',
                                                                    color: '#495057',
                                                                    whiteSpace: 'pre-wrap',
                                                                    margin: 0,
                                                                    background: 'transparent',
                                                                    border: 'none'
                                                                }}>
                                                                    {emailBody}
                                                                </pre>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {/* All Attachments Card */}
                                    <div className="row">
                                        <div className="col-sm-12">
                                            <div className="card">
                                                <div className="card-header" style={{
                                                    background: '#4facfe',
                                                    color: 'white',
                                                    padding: '15px 20px',
                                                    display: 'flex',
                                                    justifyContent: 'space-between',
                                                    alignItems: 'center'
                                                }}>
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '15px' }}>
                                                        <h5 style={{ margin: 0, fontSize: '18px', fontWeight: 600 }}>
                                                            <i className="fa fa-paperclip"></i> All Attachments ({allAttachments.length})
                                                        </h5>
                                                        <div className="form-check" style={{ margin: 0 }}>
                                                            <input
                                                                type="checkbox"
                                                                className="form-check-input"
                                                                id="selectAllAttachments"
                                                                checked={isSelectAll && pdfAttachments.length > 0}
                                                                onChange={this.handleSelectAll}
                                                                disabled={pdfAttachments.length === 0}
                                                                style={{
                                                                    width: '18px',
                                                                    height: '18px',
                                                                    cursor: pdfAttachments.length > 0 ? 'pointer' : 'not-allowed',
                                                                    marginTop: '0px'
                                                                }}
                                                            />
                                                            <label
                                                                className="form-check-label"
                                                                htmlFor="selectAllAttachments"
                                                                style={{
                                                                    fontSize: '14px',
                                                                    fontWeight: 500,
                                                                    marginLeft: '5px',
                                                                    cursor: pdfAttachments.length > 0 ? 'pointer' : 'default',
                                                                    opacity: pdfAttachments.length > 0 ? 1 : 0.5
                                                                }}
                                                            >
                                                                Select All PDFs ({pdfAttachments.length})
                                                            </label>
                                                        </div>
                                                        <span style={{ fontSize: '14px', opacity: 0.9 }}>
                                                            PDFs Selected: {selectedAttachments.length} / {pdfAttachments.length}
                                                        </span>
                                                    </div>
                                                    {!this.state.fromFileDashboard && hasPdfAttachments ? (
                                                        <button
                                                            onClick={this.handleUploadSelected}
                                                            style={{
                                                                background: selectedAttachments.length > 0 ? '#28a745' : '#6c757d',
                                                                color: 'white',
                                                                border: 'none',
                                                                padding: '8px 20px',
                                                                borderRadius: '5px',
                                                                cursor: selectedAttachments.length > 0 ? 'pointer' : 'not-allowed',
                                                                fontSize: '14px',
                                                                fontWeight: 600,
                                                                display: 'flex',
                                                                alignItems: 'center',
                                                                gap: '8px',
                                                                transition: 'all 0.3s ease',
                                                                opacity: selectedAttachments.length > 0 ? 1 : 0.7
                                                            }}
                                                            onMouseEnter={(e) => {
                                                                if (selectedAttachments.length > 0) {
                                                                    e.currentTarget.style.background = '#218838';
                                                                    e.currentTarget.style.transform = 'translateY(-2px)';
                                                                }
                                                            }}
                                                            onMouseLeave={(e) => {
                                                                if (selectedAttachments.length > 0) {
                                                                    e.currentTarget.style.background = '#28a745';
                                                                    e.currentTarget.style.transform = 'translateY(0)';
                                                                }
                                                            }}
                                                            disabled={selectedAttachments.length === 0}
                                                        >
                                                            <i className="fa fa-upload"></i> Upload Selected PDFs ({selectedAttachments.length})
                                                        </button>
                                                    ) : (!this.state.fromFileDashboard && allAttachments.length > 0) ? (
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                            <span style={{ fontSize: '14px', color: '#ff6b6b', fontWeight: 500 }}>
                                                                <i className="fa fa-info-circle"></i> No PDF files to upload
                                                            </span>
                                                        </div>
                                                    ) : null}
                                                </div>
                                                <div className="card-body" style={{ padding: '25px' }}>
                                                    {allAttachments.length === 0 ? (
                                                        <div className="text-center py-4">
                                                            <i className="fa fa-file-o" style={{ fontSize: '48px', color: '#ddd' }}></i>
                                                            <p className="mt-3 text-muted">No attachments found</p>
                                                        </div>
                                                    ) : (
                                                        <div className="row">
                                                            {allAttachments.map((attachment) => {
                                                                const isPdf = this.isPdfAttachment(attachment);
                                                                const isImage = this.isImageAttachment(attachment);
                                                                const isSelected = selectedAttachments.includes(attachment.id);
                                                                return (
                                                                    <div
                                                                        key={`${attachment.mail_thread_id ?? "m"}-${attachment.id}`}
                                                                        className="col-md-4 col-sm-6 mb-4"
                                                                    >
                                                                        <div style={{
                                                                            border: isSelected ? '2px solid #28a745' : '2px solid #e9ecef',
                                                                            borderRadius: '10px',
                                                                            padding: '20px',
                                                                            transition: 'all 0.3s ease',
                                                                            cursor: isPdf ? 'pointer' : 'default',
                                                                            background: isPdf ? (isSelected ? '#f8fff9' : 'white') : '#f8f9fa',
                                                                            boxShadow: isSelected ? '0 4px 8px rgba(40, 167, 69, 0.2)' : '0 2px 4px rgba(0,0,0,0.05)',
                                                                            height: '100%',
                                                                            position: 'relative',
                                                                            opacity: isPdf ? 1 : 0.7
                                                                        }}
                                                                            className="attachment-card"
                                                                            onMouseEnter={(e) => {
                                                                                if (isPdf && !isSelected) {
                                                                                    e.currentTarget.style.transform = 'translateY(-5px)';
                                                                                    e.currentTarget.style.boxShadow = '0 8px 16px rgba(0,0,0,0.1)';
                                                                                    e.currentTarget.style.borderColor = '#4facfe';
                                                                                }
                                                                            }}
                                                                            onMouseLeave={(e) => {
                                                                                if (isPdf && !isSelected) {
                                                                                    e.currentTarget.style.transform = 'translateY(0)';
                                                                                    e.currentTarget.style.boxShadow = isSelected
                                                                                        ? '0 4px 8px rgba(40, 167, 69, 0.2)'
                                                                                        : '0 2px 4px rgba(0,0,0,0.05)';
                                                                                    e.currentTarget.style.borderColor = isSelected ? '#28a745' : '#e9ecef';
                                                                                }
                                                                            }}
                                                                            onClick={() => isPdf && this.handleAttachmentSelect(attachment.id)}
                                                                        >
                                                                            {/* Checkbox in top-right corner - only show for PDFs */}
                                                                            {isPdf && (
                                                                                <div style={{
                                                                                    position: 'absolute',
                                                                                    top: '10px',
                                                                                    right: '10px',
                                                                                    zIndex: 2
                                                                                }}>
                                                                                    <input
                                                                                        type="checkbox"
                                                                                        checked={isSelected}
                                                                                        onChange={(e) => {
                                                                                            e.stopPropagation();
                                                                                            this.handleAttachmentSelect(attachment.id);
                                                                                        }}
                                                                                        onClick={(e) => e.stopPropagation()}
                                                                                        style={{
                                                                                            width: '20px',
                                                                                            height: '20px',
                                                                                            cursor: 'pointer',
                                                                                            accentColor: '#28a745'
                                                                                        }}
                                                                                    />
                                                                                </div>
                                                                            )}

                                                                            {/* Non-selectable indicator for non-PDFs */}
                                                                            {!isPdf && (
                                                                                <div style={{
                                                                                    position: 'absolute',
                                                                                    top: '10px',
                                                                                    right: '10px',
                                                                                    background: '#6c757d',
                                                                                    color: 'white',
                                                                                    fontSize: '10px',
                                                                                    padding: '2px 6px',
                                                                                    borderRadius: '3px',
                                                                                    fontWeight: 'bold'
                                                                                }}>
                                                                                    VIEW ONLY
                                                                                </div>
                                                                            )}

                                                                            <div style={{ textAlign: 'center', marginBottom: '15px' }}>
                                                                                {isPdf ? (
                                                                                    <i className="fa fa-file-pdf-o" style={{
                                                                                        fontSize: '48px',
                                                                                        color: '#dc3545'
                                                                                    }}></i>
                                                                                ) : isImage ? (
                                                                                    <i className="fa fa-file-image-o" style={{
                                                                                        fontSize: '48px',
                                                                                        color: '#28a745'
                                                                                    }}></i>
                                                                                ) : (
                                                                                    <i className="fa fa-file-o" style={{
                                                                                        fontSize: '48px',
                                                                                        color: '#6c757d'
                                                                                    }}></i>
                                                                                )}
                                                                            </div>
                                                                            <div style={{ marginBottom: '12px' }}>
                                                                                <p style={{
                                                                                    margin: 0,
                                                                                    fontSize: '14px',
                                                                                    fontWeight: 600,
                                                                                    color: isPdf ? '#2c3e50' : '#6c757d',
                                                                                    wordBreak: 'break-word',
                                                                                    paddingRight: isPdf ? '25px' : '0'
                                                                                }}>
                                                                                    {attachment.original_filename}
                                                                                </p>
                                                                                <small style={{
                                                                                    color: isPdf ? '#6c757d' : '#adb5bd',
                                                                                    fontSize: '12px',
                                                                                    display: 'block',
                                                                                    marginTop: '4px'
                                                                                }}>
                                                                                    Size: {attachment.file_size_formatted}
                                                                                </small>
                                                                                <small style={{
                                                                                    color: isPdf ? '#999' : '#ced4da',
                                                                                    fontSize: '11px',
                                                                                    display: 'block',
                                                                                    marginTop: '2px'
                                                                                }}>
                                                                                    Received: {attachment.email_date}
                                                                                </small>
                                                                                {!isPdf && (
                                                                                    <small style={{
                                                                                        color: '#ff6b6b',
                                                                                        fontSize: '11px',
                                                                                        display: 'block',
                                                                                        marginTop: '4px',
                                                                                        fontWeight: 'bold'
                                                                                    }}>
                                                                                        ⓘ Only PDF files can be uploaded
                                                                                    </small>
                                                                                )}
                                                                            </div>
                                                                            <div style={{
                                                                                display: 'flex',
                                                                                justifyContent: 'space-between',
                                                                                gap: '8px',
                                                                                marginTop: '15px'
                                                                            }}>
                                                                                <button
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        this.viewAttachment(attachment);
                                                                                    }}
                                                                                    style={{
                                                                                        flex: 1,
                                                                                        padding: '8px',
                                                                                        background: '#4facfe',
                                                                                        color: 'white',
                                                                                        border: 'none',
                                                                                        borderRadius: '5px',
                                                                                        cursor: 'pointer',
                                                                                        fontSize: '14px'
                                                                                    }}
                                                                                    title="View"
                                                                                >
                                                                                    <i className="fa fa-eye"></i> View
                                                                                </button>
                                                                                <button
                                                                                    onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        this.downloadAttachment(attachment);
                                                                                    }}
                                                                                    style={{
                                                                                        flex: 1,
                                                                                        padding: '8px',
                                                                                        background: '#28a745',
                                                                                        color: 'white',
                                                                                        border: 'none',
                                                                                        borderRadius: '5px',
                                                                                        cursor: 'pointer',
                                                                                        fontSize: '14px'
                                                                                    }}
                                                                                    title="Download"
                                                                                >
                                                                                    <i className="fa fa-download"></i> Download
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                );
                                                            })}
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* All Emails Thread Card */}
                                    {fileDetails.emails && fileDetails.emails.length > 1 && (
                                        <div className="row mt-4">
                                            <div className="col-sm-12">
                                                <div className="card">
                                                    <div className="card-header" style={{
                                                        background: '#a8edea',
                                                        color: '#495057',
                                                        padding: '15px 20px'
                                                    }}>
                                                        <h5 style={{ margin: 0, fontSize: '18px', fontWeight: 600 }}>
                                                            <i className="fa fa-exchange"></i> Email Thread ({fileDetails.emails.length} emails)
                                                        </h5>
                                                    </div>
                                                    <div className="card-body" style={{ padding: '0' }}>
                                                        <div className="email-thread" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                                                            {fileDetails.emails.map((email, index) => (
                                                                <div key={email.id} style={{
                                                                    padding: '20px',
                                                                    borderBottom: '1px solid #e9ecef',
                                                                    background: index === 0 ? '#f8f9fa' : 'white'
                                                                }}>
                                                                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                                                                        <div>
                                                                            <strong style={{ color: '#495057' }}>
                                                                                {email.from_email_parsed?.[0]?.name || email.from_email_parsed?.[0]?.email || 'Unknown'}
                                                                            </strong>
                                                                            {email.attachments && email.attachments.length > 0 && (
                                                                                <span style={{
                                                                                    marginLeft: '10px',
                                                                                    fontSize: '12px',
                                                                                    color: '#6c757d',
                                                                                    background: '#e9ecef',
                                                                                    padding: '2px 8px',
                                                                                    borderRadius: '10px'
                                                                                }}>
                                                                                    <i className="fa fa-paperclip"></i> {email.attachments.length}
                                                                                </span>
                                                                            )}
                                                                        </div>
                                                                        <small style={{ color: '#6c757d' }}>
                                                                            {email.received_at_formatted}
                                                                        </small>
                                                                    </div>
                                                                    <div style={{ marginBottom: '8px' }}>
                                                                        <strong style={{ color: '#495057' }}>Subject:</strong> {email.subject}
                                                                    </div>
                                                                    {this.renderThreadEmailBodyText(email)}
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                    {/* Upload Modal */}
                                    <div
                                        className="modal fade bd-example-modal-lg"
                                        id="upload-modal"
                                        tabIndex={-1}
                                        role="dialog"
                                        aria-hidden="true"
                                    >
                                        <div
                                            className="modal-dialog"
                                            style={{ maxWidth: "1400px" }}
                                            role="document"
                                        >
                                            <div className="modal-content">
                                                <div className="modal-header">
                                                    <h5 className="modal-title">Upload Response for {fileDetails.file_name || fileDetails.file_number}</h5>
                                                    <button
                                                        type="button"
                                                        className="close"
                                                        data-dismiss="modal"
                                                        aria-label="Close"
                                                    >
                                                        <span aria-hidden="true">&times;</span>
                                                    </button>
                                                </div>
                                                <div className="modal-body">
                                                    <div className="text-right">
                                                        <button
                                                            type="button"
                                                            className="btn btn-primary btn-sm upload-document-button"
                                                            onClick={() => this.addUploadDocument()}
                                                        >
                                                            Add Document +
                                                        </button>
                                                    </div>
                                                    {this.state.base.length > 0 &&
                                                        this.state.base.map((document, index) => (
                                                            <DashUploadDocument
                                                                key={index}
                                                                baseDetails={document}
                                                                handleDocumentDetailsChange={
                                                                    this.handleDocumentDetailsChange
                                                                }
                                                                handleDocumentFilesChange={
                                                                    this.handleDocumentFilesChange1
                                                                }
                                                                deleteDocumentDetails={this.deleteDocumentDetails}
                                                                deleteFile={this.deleteFile}
                                                                deedList={this.state.deeds}
                                                                previewDoc={this.previewDoc}
                                                                categoriesList={this.state.categoriesList}
                                                                index={index}
                                                                newfile={false}
                                                                path="querymaildetails"
                                                                state={this.state}
                                                                isbtnload={this.state.isbtnload}
                                                                pendingQueryOptions={this.getPendingQueryDropdownOptions()}
                                                            />
                                                        ))}
                                                    <div className="modal-footer" style={{ border: "none" }}>
                                                        <div style={{ margin: "auto" }}>
                                                            {this.state.base.length > 0 && (
                                                                <>
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-secondary"
                                                                        data-dismiss="modal"
                                                                        onClick={this.closeuploadfile}
                                                                    >
                                                                        Cancel
                                                                    </button>
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-primary"
                                                                        style={{ margin: "auto" }}
                                                                        disabled={this.state.uploadbtn == true}
                                                                        onClick={(e) => this.validateRequiredFileds(e)}
                                                                    >
                                                                        {this.state.isbtnload && (
                                                                            <i className="fa fa-spinner fa-spin"></i>
                                                                        )}
                                                                        Confirm
                                                                    </button>
                                                                </>
                                                            )}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* Preview Document Modal */}
                                    <div
                                        className={`modal ${this.state.previewDoc ? "open" : ""}`}
                                        id="preview-document"
                                        role="dialog"
                                        aria-hidden={this.state.previewDoc === ""}
                                        {...(this.state.previewDoc === "" && { inert: "" })}
                                    >
                                        <div className="modal-dialog modal-lg" role="document" style={{ maxWidth: "1400px" }}>
                                            <div className="modal-content" style={{ height: "90vh" }}>
                                                <div className="modal-header">
                                                    <h5 className="modal-title">Document Preview</h5>
                                                    <button
                                                        type="button"
                                                        className="close cursor-pointer"
                                                        data-dismiss="modal"
                                                        aria-label="Close"
                                                        onClick={() => this.setState({ previewDoc: "" })}
                                                    >
                                                        <span aria-hidden={this.state.previewDoc === ""}>&times;</span>
                                                    </button>
                                                </div>
                                                <div className="modal-body">
                                                    <iframe
                                                        width="100%"
                                                        height="100%"
                                                        src={this.state.previewDoc}
                                                    ></iframe>
                                                </div>
                                                <div className="modal-footer">
                                                    <button
                                                        type="button"
                                                        className="btn btn-secondary"
                                                        data-dismiss="modal"
                                                        onClick={() => this.setState({ previewDoc: "" })}
                                                    >
                                                        Close
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* View Attachment Modal */}
                                    <div className={`modal ${showViewModal ? "open" : ""}`} id="preview-document" tabIndex={-1} role="dialog" aria-labelledby="viewAttachmentLabel" aria-modal="true">
                                        <div className="modal-dialog modal-lg" style={{ maxWidth: "95vw", height: "95vh", margin: "2.5vh auto" }}>
                                            <div className="modal-content" style={{ height: "100%" }}>
                                                <div className="modal-header" style={{ background: '#f8f9fa', borderBottom: '1px solid #dee2e6' }}>
                                                    <h5 className="modal-title" id="viewAttachmentLabel" style={{ margin: 0, fontSize: '16px', fontWeight: 600 }}>
                                                        <i className="fa fa-eye"></i> Viewing: {viewAttachment?.original_filename}
                                                    </h5>
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                        <button
                                                            type="button"
                                                            className="btn btn-sm btn-success"
                                                            onClick={() => viewAttachment && this.downloadAttachment(viewAttachment)}
                                                            style={{ padding: '5px 15px', fontSize: '14px' }}
                                                        >
                                                            <i className="fa fa-download"></i> Download
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="close"
                                                            onClick={this.closeViewModal}
                                                            style={{ fontSize: '24px', padding: 0, background: 'transparent', border: 'none' }}
                                                        >
                                                            <span aria-hidden="true">&times;</span>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div className="modal-body" style={{ padding: 0, height: 'calc(100% - 60px)', overflow: 'hidden' }}>
                                                    {viewLoading ? (
                                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                                            <div className="spinner-border text-primary" role="status">
                                                                <span className="sr-only">Loading...</span>
                                                            </div>
                                                            <span style={{ marginLeft: '10px' }}>Loading document...</span>
                                                        </div>
                                                    ) : viewAttachment ? (
                                                        <div style={{ height: '100%', width: '100%', display: 'flex', flexDirection: 'column' }}>
                                                            <div style={{
                                                                padding: '10px 20px',
                                                                background: '#f8f9fa',
                                                                borderBottom: '1px solid #dee2e6',
                                                                fontSize: '12px',
                                                                color: '#6c757d'
                                                            }}>
                                                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                                                    <div>
                                                                        <strong>File:</strong> {viewAttachment.original_filename} |
                                                                        <strong> Size:</strong> {viewAttachment.file_size_formatted} |
                                                                        <strong> Type:</strong> {viewAttachment.file_type}
                                                                    </div>
                                                                    <div>
                                                                        <strong>From:</strong> {viewAttachment.email_from} |
                                                                        <strong> Date:</strong> {viewAttachment.email_date}
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div style={{ flex: 1, overflow: 'auto', padding: '20px', background: '#f5f5f5' }}>
                                                                {this.isPdfAttachment(viewAttachment) ? (
                                                                    <iframe
                                                                        src={viewAttachment.download_url}
                                                                        title={viewAttachment.original_filename}
                                                                        style={{
                                                                            width: '100%',
                                                                            height: '100%',
                                                                            border: 'none',
                                                                            borderRadius: '5px',
                                                                            boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
                                                                        }}
                                                                    />
                                                                ) : this.isImageAttachment(viewAttachment) ? (
                                                                    <div style={{
                                                                        display: 'flex',
                                                                        justifyContent: 'center',
                                                                        alignItems: 'center',
                                                                        height: '100%'
                                                                    }}>
                                                                        <img
                                                                            src={viewAttachment.download_url}
                                                                            alt={viewAttachment.original_filename}
                                                                            style={{
                                                                                maxWidth: '100%',
                                                                                maxHeight: '100%',
                                                                                objectFit: 'contain',
                                                                                borderRadius: '5px',
                                                                                boxShadow: '0 2px 10px rgba(0,0,0,0.1)'
                                                                            }}
                                                                        />
                                                                    </div>
                                                                ) : (
                                                                    <div style={{
                                                                        display: 'flex',
                                                                        justifyContent: 'center',
                                                                        alignItems: 'center',
                                                                        height: '100%',
                                                                        flexDirection: 'column',
                                                                        background: 'white',
                                                                        borderRadius: '5px',
                                                                        padding: '40px'
                                                                    }}>
                                                                        <i className="fa fa-file-o" style={{ fontSize: '64px', color: '#6c757d', marginBottom: '20px' }}></i>
                                                                        <p style={{ color: '#6c757d', fontSize: '16px', marginBottom: '10px' }}>
                                                                            This file type cannot be previewed directly.
                                                                        </p>
                                                                        <p style={{ color: '#999', fontSize: '14px' }}>
                                                                            Please download the file to view it.
                                                                        </p>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
                                                            <p style={{ color: '#6c757d' }}>No attachment selected</p>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <Modal
                                        title="Close unwanted mail"
                                        visible={showCloseUnwantedModal}
                                        onOk={this.submitCloseUnwantedMail}
                                        onCancel={this.handleCloseUnwantedModalCancel}
                                        okText="Close mail"
                                        cancelText="Cancel"
                                        destroyOnClose
                                    >
                                        <p style={{ marginBottom: 8 }}>Please provide a reason for closing this unwanted mail:</p>
                                        <Input.TextArea
                                            rows={4}
                                            value={closeUnwantedReason}
                                            onChange={(e) => this.setState({ closeUnwantedReason: e.target.value })}
                                            placeholder="Enter reason (max 500 characters)..."
                                            maxLength={500}
                                        />
                                    </Modal>

                                    {/* Hint About Modal */}
                                    {pendingHintQuery ? (
                                        <div className="dialog-modal" role="dialog" aria-hidden="true" onClick={() => this.setState({ pendingHintQuery: null, pendingHintText: "" })}>
                                            <div className="dialog-modal-body" role="document" onClick={(e) => e.stopPropagation()}>
                                                <div className="modal-content">
                                                    <div className="modal-header">
                                                        <h5 className="modal-title">Add Hint</h5>
                                                        <button type="button" className="close" aria-label="Close" onClick={() => this.setState({ pendingHintQuery: null, pendingHintText: "" })}>
                                                            <span aria-hidden="true">&times;</span>
                                                        </button>
                                                    </div>
                                                    <div className="modal-body">
                                                        <div className="form-group mb-0">
                                                            <textarea
                                                                className="form-control"
                                                                rows={4}
                                                                placeholder="Type hint..."
                                                                value={pendingHintText}
                                                                onChange={(e) => this.setState({ pendingHintText: e.target.value })}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="modal-footer">
                                                        <button type="button" className="btn btn-secondary" onClick={() => this.setState({ pendingHintQuery: null, pendingHintText: "" })}>Cancel</button>
                                                        <button type="button" className="btn btn-primary" onClick={() => this.addHintForPendingQuery(pendingHintQuery)}>Save</button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    ) : null}

                                    <div className={`modal ${showHintModal ? "open" : ""}`} id="preview-document" tabIndex={-1} role="dialog" aria-labelledby="hintAboutFileLabel" aria-modal="true">
                                        <div className="modal-dialog modal-lg" style={{ maxWidth: "1400px" }}>
                                            <div className="modal-content" style={{ height: "90vh" }}>
                                                <div className="modal-header">
                                                    <h5 className="modal-title">Hint About File</h5>
                                                    <button
                                                        type="button"
                                                        className="close"
                                                        onClick={this.closeHintModal}
                                                    >
                                                        <span aria-hidden="true">&times;</span>
                                                    </button>
                                                </div>
                                                <div className="modal-body">
                                                    <HintAboutFile
                                                        id={this.props.match.params.id}
                                                        path='querymaildetails'
                                                        onHintSaved={this.handleHintSaved}
                                                        onAudioSaved={this.handleAudioSaved}
                                                    />
                                                </div>
                                                <div className="modal-footer">
                                                    <button
                                                        type="button"
                                                        className="btn btn-secondary"
                                                        onClick={this.closeHintModal}
                                                    >
                                                        Close
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        );
    }

    componentDidUpdate(prevProps: Readonly<AllProps>, prevState: Readonly<any>) {
        if (prevState.queryTreeIdByText !== this.state.queryTreeIdByText && Array.isArray(this.state.pendingQuerysList) && this.state.pendingQuerysList.length > 0) {
            const normalizedPending = this.normalizePendingQueryList(this.state.pendingQuerysList);
            this.setState({ pendingQuerysList: normalizedPending });
        }
    }
}

export default ReceivedQueryMailDetails;